import React from 'react';
import './index.css';

const Footer2 = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className='last-footer'>
      <div className="footer-left">
        <h5>
          © {currentYear} Be Safe Keep Safe. All rights reserved. | Privacy Policy
        </h5>
      </div>
    </footer>
  );
};

export default Footer2;
